import { defaultThisMonthRange } from "@/domain/invoices/invoiceFilterState";

export type PeriodShortcut = "last-month" | "this-month" | "last-30-days";

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

function isoDateLocal(d: Date): string {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

function monthRange(year: number, monthIndex: number): { dateFrom: string; dateTo: string } {
  const lastDay = new Date(year, monthIndex + 1, 0).getDate();
  return {
    dateFrom: `${year}-${pad2(monthIndex + 1)}-01`,
    dateTo: `${year}-${pad2(monthIndex + 1)}-${pad2(lastDay)}`,
  };
}

export function periodShortcutRange(
  key: PeriodShortcut,
): { dateFrom: string; dateTo: string } {
  const now = new Date();
  if (key === "this-month") {
    return defaultThisMonthRange();
  }
  if (key === "last-month") {
    const d = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    return monthRange(d.getFullYear(), d.getMonth());
  }
  const from = new Date(now);
  from.setDate(from.getDate() - 29);
  return { dateFrom: isoDateLocal(from), dateTo: isoDateLocal(now) };
}
